/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../shared/arial';
import ExamResultsType3 from './ExamResultsType3';
import ExamResultsType2 from './ExamResultsType2';
import ExamResultsType1 from './ExamResultsType1';
import ExamResultsType0 from './ExamResultsType0';
import { Loading } from '../../helpers/utils';

const ExamResults = () => {
  const [examType, setExamType] = useState(null);
  const location = useLocation();
  const path = location.pathname.split('/');

  useEffect(() => {
    setExamType(parseInt(path[2], 10));
  }, []);

  const redirectToResults = (type) => {
    if (examType !== null) {
      switch (type) {
        case 0:
          return <ExamResultsType0 grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} />;
        case 1:
          return <ExamResultsType1 grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} />;
        case 2:
          return <ExamResultsType2 grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} />;
        case 3:
          return <ExamResultsType3 grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} />;
        default:
          return <Loading />;
      }
    } else {
      return <Loading />;
    }
  };

  return redirectToResults(examType);
};

export default ExamResults;
